import { render, staticRenderFns } from "./kresponsivewindow.vue?vue&type=template&id=bc88b2be&scoped=true&"
import script from "./kresponsivewindow.vue?vue&type=script&lang=js&"
export * from "./kresponsivewindow.vue?vue&type=script&lang=js&"
import style0 from "./kresponsivewindow.vue?vue&type=style&index=0&id=bc88b2be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc88b2be",
  null
  
)

export default component.exports